import { Link } from "react-router-dom";
import { NewsletterSignup } from "./NewsletterSignup";

export function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-brand-green text-brand-offwhite">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="inline-block bg-brand-offwhite rounded-lg p-3">
            <img src="/logo.png" alt="Bilgece Atölye" className="w-40 h-auto" />
          </div>
          <p className="mt-5 text-brand-gold-light font-serif text-xl italic">Yaşamı öğrenmenin yolu.</p>
          <p className="mt-6 text-sm text-brand-offwhite/70 leading-relaxed">
            Daha çok bilmek için değil, daha bilgece yaşamak için.
          </p>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-brand-gold mb-5">Keşfet</h4>
          <ul className="space-y-3 text-sm text-brand-offwhite/80">
            <li><Link to="/programlar" className="hover:text-brand-gold-light">Programlar</Link></li>
            <li><Link to="/programlar/bilgece-atolye" className="hover:text-brand-gold-light">Bilgece Atölye</Link></li>
            <li><Link to="/programlar/bilgelik-pedagojisi" className="hover:text-brand-gold-light">Bilgelik Pedagojisi</Link></li>
            <li><Link to="/kutuphane" className="hover:text-brand-gold-light">Kütüphane</Link></li>
            <li><Link to="/kurumlar" className="hover:text-brand-gold-light">Kurumlar İçin</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-brand-gold mb-5">İletişim</h4>
          <p className="text-sm text-brand-offwhite/80 leading-relaxed">
            Sahrayıcedit Mah. İnönü Cad.<br />
            Aydoğanlar İş Merkezi<br />
            No:12 Kat:5 Daire:13<br />
            Kadıköy / İstanbul
          </p>
          <a href="mailto:merhaba@bilgece.life" className="block mt-4 text-sm text-brand-gold-light hover:underline">merhaba@bilgece.life</a>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-brand-gold mb-5">Bilgece Mektup</h4>
          <p className="text-sm text-brand-offwhite/70 mb-4">Haftada bir. Gürültü değil, düşünmeye değer tek bir fikir.</p>
          <NewsletterSignup variant="footer" />
        </div>
      </div>

      <div className="border-t border-brand-offwhite/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-brand-offwhite/50">
          <span>© {new Date().getFullYear()} Bilgece™. Tüm hakları saklıdır.</span>
          <span>Türkiye'den doğan bir öğrenme ve yaşam ekosistemi.</span>
        </div>
      </div>
    </footer>
  );
}
